import React, { Component } from "react";
import "../../assets/styles/AppNotFound.css";

const AppNotFound = () => {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>Oops!</h1>
          <h2>The Application not found</h2>
        </div>
      </div>
    </div>
  );
};

export default AppNotFound;
